import { Component, AfterViewInit, HostListener, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
@Component({
  selector: 'app-foreword',
  templateUrl: './foreword.component.html',
  styleUrls: ['./foreword.component.scss']
})
export class ForewordComponent implements AfterViewInit, OnInit {
  windowsWidth;
  activeElement = 'forewordTxt';

  contributors = [
    {
      name: 'Aakshi Magazine',
      description: 'Writer, ',
      articleName: 'Odd Men Out',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Aakshi.png',
      subText: 'The wordsmith and academic, who has a PhD in film studies, writes extensively on cinema and culture. She likes teaching, writing, cats and working at her own pace in New Delhi.'
    },
    {
      name: 'Aditya Dutta',
      description: 'Illustrator, ',
      articleName: 'Odd Men Out',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Aditya Dutta.png',
      subText: 'The New Delhi-based mixed media artist and photographer is one of India’s most promising young talents. His creative sensibility drives him to combine Indian aesthetics with Western art-at-large. The primary form he works with is analogue collage art.'
    },
    {
      name: 'Akshaya Pillai',
      description: 'Writer, ',
      articleName: 'Rise and Fall',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Akshaya.png',
      subText: 'Her anxieties can only be tamed using a pen. Her hometown, Thiruvananthapuram, its many eccentricities and wonderful people find their place in her stories, which have earlier been featured in a number of leading Indian publications. She currently leads a hermit’s life in a dilapidated 100-year-old house with a bunch of cats, a dog and some visiting hawks.'
    },
    {
      name: 'Ananya Arya',
      description: 'Illustrator, ',
      articleName: 'Sense and Sensitivity',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Ananya.png',
      subText: 'The graphic design student of the National Institute of Design, Ahmedabad harbours a deep appreciation for the analogue. She displays a profound affinity for colours and is likely to be found thinking, reading and talking about design, human psyche, philosophy, politics, fiction and dogs.'
    },
    {
      name: 'Ankit Verma',
      description: 'Performance Artist, ',
      articleName: 'A View with a Room',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Ankit Verma.png',
      subText: 'The Mumbai resident is a cinema and literature enthusiast. He prides himself on being a part-time culture vulture and full-time performer who is constantly playing to the cameras in his room.'
    },
    {
      name: 'Anuj Malhotra',
      description: 'Writer and Moderator, ',
      articleName: 'The Sum of Their Parts',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Anuj Malhotra.png',
      subText: 'The critic, curator and cultural activist from New Delhi is the founder of Lightcube, an acclaimed film collective and leading resource for pioneering research and presentation of image forms in the country.'
    },
    {
      name: 'Bishakha Datta',
      description: 'Film-maker and Activist, ',
      articleName: 'Eyes of the Beholder',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Bishakha Datta.png',
      subText: 'She works extensively on gender and sexuality in the digital space and is the co-founder of the non-profit organisation Point of View, in Mumbai. Her documentary work includes ',
      italictext1: 'In The Flesh ',
      italictext2: 'Taaza Khabar ',
      italictext3: 'Deep Dives.',
      subtext2: '(2003) and ',
      subtext3: '(2007). She also co-founded the award-winning online imprint, ',
    },
    {
      name: 'Divya Balakrishnan',
      description: 'Stylist, ',
      articleName: 'Rise and Fall',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Divya Balkrishnan.png',
      subText: 'The first creative professional from an all-science family is a passionate over-thinker and middle-of-the-night creator who is extremely curious about our cultural economy. She fell in love with fashion at an early age when she was introduced to Audrey Hepburn and Edith Head.'
    },
    {
      name: 'Farhan Hussain',
      description: 'Photographer, ',
      articleName: 'Zen and the Art of Anjali Patil',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Farhan .png',
      subText: 'The work of the fashion and commercial lensman who hails from Assam has been featured in several national and international publications. He has also worked on numerous advertising campaigns. In 2017, he was nominated for Photographer of the Year at the EyeEm Photography Festival & Awards in Berlin.'
    },
    {
      name: 'Harshal Duddalwar',
      description: 'Designer, ',
      articleName: 'The Cinema Issue',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/HarshalD.png',
      subText: 'The Nagpur denizen strives to balance functionality with aesthetics as he practises independently within the verticals of traditional graphic and experience design. He often works in collaboration with other creatives and teams and is interested in semiotics, typography, brands and their philosophies, and he loves to talk about Muji.'
    },
    {
      name: 'Indra Joshi',
      description: 'Videographer, ',
      articleName: 'Zen and the Art of Anjali Patil',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Indra Joshi.png',
      subText: 'His images are marked by an experimental play of light and shadow, and his unorthodox frames and angles add a unique personality to his work. He captures the essence of the mundane and removes meaning and context from subjects and spaces that dance gently outside the lines of expectation while operating within formal stages.'
    },
    {
      name: 'Lekha Rathnam',
      description: 'Photographer, ',
      articleName: 'Rise and Fall',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Lekha.png',
      subText: 'The self-taught photographer from Bengaluru was gifted a Nikon point-and-shoot by her father when she was in the eighth standard, and she’s been inseparable from a camera ever since. She loves photographing people, and her trademark style consists of minimalist, clean and desaturated tones with a strong yet subtle call-out to aspects of Indian culture.'
    },
    {
      name: 'Nikhil D',
      description: 'Stylist, ',
      articleName: 'Zen and the Art of Anjali Patil',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Nikhil D.png',
      subText: 'For over a decade, the co-founder of the creative and modelling agency Feat.Artists has been contributing to the Indian design and fashion industry – with editorial covers and features, styled campaigns, runway shows and more. Experimenting with digital media and film has always been something that the Mumbai-based stylist has wanted to explore.'
    },
    {
      name: 'Nolina S. Minj',
      description: 'Writer, ',
      articleName: 'Zen and the Art of Anjali Patil',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Nolina Minj.png',
      subText: 'The Adivasi feminist researcher, writer and editor based in Mumbai has also worked in the social sector on gender issues such as violence against women, migration, housing rights and marginalised feminisms among others. She has an Erasmus Mundus Master’s in Comparative Literature and Cultural Studies, and in her free time, she likes to read diverse writers of colour.'
    },
    {
      name: 'Ravi Motasra',
      description: 'Developer, ',
      articleName: 'The Cinema Issue',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Ravi.png',
      subText: 'He hails from Jaipur but currently calls Bengaluru his home. An interesting combination of a nerd and pro-basketball player – who also loves food and dogs – he enjoys bringing interactive and visual design principles to life on the web.'
    },
    {
      name: 'Vasu Primlani',
      description: 'Writer, ',
      articleName: 'Adults Only',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Vasu Primlani.png',
      subText: 'A professional corporate trainer, award-winning environmentalist and a stand-up comedian originally from the US, she keenly observes and draws from life around her. She has raised questions about notions of normal and questions societal stereotypes.'
    },
    {
      name: 'Veer Misra',
      description: 'Illustrator and Visual Artist, ',
      articleName: 'Love Language',
      isActive: false,
      imgUrl: '../cinemaissue/assets/images/Veer.png',
      subText: 'His work attempts to thematically explore love, masculinity, mental health and intimacy as part of queer storytelling. In addition to his illustrative creations, he also curates and publishes ',
      italictext1: 'mush',
      subtext2: ', a bi-monthly newsletter based out of Delhi that spotlights South Asian queer essays about loving, longing, losing and learning.'
    }
  ];

  constructor() { }

  ngOnInit() {
    this.windowsWidth = window.innerWidth;
    this.goBackToTop();
  }

  ngAfterViewInit() {

  }

  gotoTop() {
    document.getElementById('parentWrap').scrollTo({ 'top': 0, behavior: 'smooth' });
  }

  gotoEle(id) {
    this.activeElement = id;
    document.getElementById(id).scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  updateLinks() {
    if (document.getElementById('forewordTxt').getBoundingClientRect().top < (window.innerHeight / 2)) {
      this.activeElement = 'forewordTxt';
    }
    if (document.getElementById('featuringTxt').getBoundingClientRect().top < (window.innerHeight / 2)) {
      this.activeElement = 'featuringTxt';
    }
    if (document.getElementById('aboutTxt').getBoundingClientRect().top < (window.innerHeight / 2)) {
      this.activeElement = 'aboutTxt';
    }
  }

  goBackToTop() {
    document.getElementsByTagName('body')[0].scroll({
      top: 0,
      behavior: 'smooth'
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowsWidth = window.innerWidth;
  }

}
